// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import { Card, Container, Row, Col, Spinner } from 'react-bootstrap'
// import { useParams } from 'react-router-dom'

// const Learnyou = () => {
//   const { id } = useParams()
//   const [course, setCourse] = useState({})
//   const [courseKeyPoints, setCourseKeyPoints] = useState([])
//   const [loading, setLoading] = useState(true) // Initialize loading state
//   const token = localStorage.getItem('jwttoken')
//   const url = 'https://kaasbackend.vetrinahealthcare.com/'

//   useEffect(() => {
//     setLoading(true) // Set loading to true when API call starts
//     axios
//       .get(`${url}lms/courses/${id}/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         console.log('API Response:', response.data) // Debugging line
//         setCourse(response.data)
//         setCourseKeyPoints(response.data.course_key_points || [])
//         setLoading(false) // Set loading to false when data is fetched
//       })
//       .catch((error) => {
//         console.error('Error fetching course:', error)
//         setLoading(false) // Set loading to false in case of an error
//       })
//   }, [id, token, url])

//   return (
//     <Container className='mt-3 ms-2'>
//       <Row className='justify-content-center'>
//         <Col md={7} sm={8} xs={10}>
//           <Card
//             className='shadow-lg border-0 rounded'
//             style={{ marginLeft: '-1rem' }}
//           >
//             <Card.Body className='ms-3'>
//               <h5 className='fw-bold mt-3'>What You'll Learn</h5>
//               {loading ? (
//                 <div className='d-flex justify-content-center'>
//                   <Spinner animation='border' variant='primary' />
//                 </div>
//               ) : courseKeyPoints.length > 0 ? (
//                 <ul>
//                   {courseKeyPoints.map((point, index) => (
//                     <li key={index}>
//                       <strong>{index + 1}.</strong> {point}
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p>No key points available.</p>
//               )}
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   )
// }

// export default Learnyou
import React from 'react'

export default function Learnyou() {
  return (
    <div>
      
    </div>
  )
}
